import {
  Button,
  CircularProgress,
  Stack,
  TableCell,
  TableRow,
  Typography,
} from "@hiver/hiver-ui-kit";
import React from "react";
import SVGInline from "react-svg-inline";
import { openMailUsingThreadId, sendTrackingEvent } from "../../../helpers";
import { useGetThreadId } from "../../../hooks/useGetThreadId";
import PopoutIcon from "../../../images/popout.svg";

const styles = {
  row: {
    backgroundColor: "gray.background",
    "&:hover": {
      backgroundColor: "background.paper",
      boxShadow: "0px 1px 3px 0px #d7d8da",
      position: "relative",
      zIndex: 1,
    },
  },
  emailCell: {
    width: "200px",
    "&:hover #conversation-row-email": {
      color: "blue.primary",
    },
    "&:hover #conversation-row-email-svg": {
      display: "inline !important",
    },
  },
  emailCellContainer: {
    flexDirection: "row",
    width: "100%",
    gap: 0.5,
    "&:hover": { cursor: "pointer" },
  },
  textOverflow: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
};

const ConversationRow = ({ conversation, testResults, onTestClicked, disableAllTestButton, gainsightProps={} }) => {
  const conversationId = conversation.gmailunit_id;
  const { data, refetch } = useGetThreadId({
    gmailunitId: conversationId,
    isEnabled: false,
  });
  const isLoading = testResults?.[conversationId]?.isLoading ?? false;
  const result = testResults?.[conversationId]?.result ?? "";

  const onEmailClicked = () => {
    if (!data) {
      refetch().then((res) => {
        const threadId = res?.data?.data?.first_message_id;
        openMailUsingThreadId(threadId);
      });
    } else {
      const threadId = data?.data?.first_message_id;
      openMailUsingThreadId(threadId);
    }
  };

  const handleTestClick = () => {
    onTestClicked(conversationId);
    sendTrackingEvent("AI_CF_Test_page_testsingle", {...gainsightProps});
  };
  return (
    <TableRow sx={styles.row}>
      <TableCell sx={styles.emailCell}>
        <Stack sx={styles.emailCellContainer} onClick={onEmailClicked}>
          <Typography
            variant="h3"
            id="conversation-row-email"
            sx={{ ...styles.textOverflow }}
          >
            {conversation.contact}
          </Typography>
          <SVGInline
            svg={PopoutIcon}
            id="conversation-row-email-svg"
            style={{ display: "none", marginTop: "4px" }}
            width="auto"
            height="14px"
          />
        </Stack>
        <Typography variant="body2" sx={{ ...styles.textOverflow }}>
          {conversation.subject}
        </Typography>
      </TableCell>
      <TableCell sx={{ width: "70px" }}>
        <Button
          variant="outlined"
          size="small"
          color="tertiary"
          onClick={handleTestClick}
          disabled={isLoading || disableAllTestButton}
          endIcon={
            isLoading ? (
              <CircularProgress size={10} sx={{ color: "gray.black" }} />
            ) : null
          }
        >
          {isLoading ? "Testing" : "Test"}
        </Button>
      </TableCell>
      <TableCell>
        <Typography variant="body2">{result}</Typography>
      </TableCell>
    </TableRow>
  );
};

export default ConversationRow;
